import { useUnit } from 'effector-react'

import { IconLoading } from '@/assets/icons/icon-loading'
import { RefreshIcon } from '@/assets/icons/icon-refresh.tsx'
import { Button } from '@/components/ui/button.tsx'
import {
  $chatSuggestions,
  $hasChatSuggestions,
  regenerateSuggestionsFx,
  translateSuggestionsFx,
} from '@/models/chattingUI/chatSuggestions/chatSuggestions'
import { $isAnySendingForFan } from '@/models/chattingUI/chatSuggestions/messageSendingTracker'
import { $fanId } from '@/models/chattingUI/chats/chats.ts'
import { $messages } from '@/models/chattingUI/messages/messages.ts'
import { noop } from '@/utils/misc'

import { ChatSuggestionsBlock } from './ChatSuggestionsBlock'
import { ChatSuggestionsHeader } from './ChatSuggestionsHeader'

export const ChatSuggestions = () => {
  const chatSuggestions = useUnit($chatSuggestions)
  const hasChatSuggestions = useUnit($hasChatSuggestions)
  const messages = useUnit($messages)
  const fanId = useUnit($fanId)
  const isTranslatingSuggestions = useUnit(translateSuggestionsFx.pending)
  const isLastMessageFromFan =
    messages.length > 0 && messages[messages.length - 1]?.fromUser?.id === fanId
  const isRegenerating = useUnit(regenerateSuggestionsFx.pending)

  const chatActiveSuggestions = fanId ? chatSuggestions[+fanId] : null

  const isLoading = useUnit($isAnySendingForFan(fanId || 0))

  const handleRegenerate = () => regenerateSuggestionsFx()

  if (
    isLoading ||
    !hasChatSuggestions ||
    !chatSuggestions ||
    !chatActiveSuggestions ||
    isTranslatingSuggestions
  ) {
    return (
      <div className="relative">
        <div className="pt-5 bottom-full left-0 w-full z-20 -translate-y-2">
          <div className="relative rounded-lg p-[1px] bg-gradient-to-r from-[#FF6DEC] via-[#C76DFF] via-[#836DFF] via-[#6DC0FF] via-[#6DFFF5] to-[#6DFFB9] animate-gradient-rotate">
            <div className="bg-card px-6 py-4 rounded-lg w-full overflow-hidden gap-4 flex flex-col">
              <ChatSuggestionsHeader
                step="view"
                onBack={noop}
              />
              <div className="flex flex-col items-center justify-center flex-1 py-8">
                <div className="flex items-center justify-center gap-3 pb-4 flex-1">
                  <IconLoading className="h-6 w-6 animate-spin text-primary-500" />
                  <span className="text-sm font-medium text-text-default">
                    {isLastMessageFromFan
                      ? 'Creating the best suggestions for you'
                      : 'Waiting for the fan’s response to create suggestions'}
                  </span>
                </div>
                <Button
                  onClick={handleRegenerate}
                  variant="outline"
                  disabled={isRegenerating || isLoading}
                  className="flex items-center gap-2 px-4 py-2 hover:bg-primary-400"
                >
                  <RefreshIcon
                    arrowColor="currentColor"
                    className={`h-4 w-4 ${isRegenerating ? 'animate-spin' : ''}`}
                  />
                  <span className="text-sm font-medium">Regenerate</span>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="relative">
      <ChatSuggestionsBlock suggestions={chatActiveSuggestions} />
    </div>
  )
}
